// generated by genversion
export var version = '4.5.4';
//# sourceMappingURL=version.js.map